module.exports = __webpack_public_path__ + "img/heibai.30c2bc8b.png";